$(document).ready(function() {
    'use strict';

    $.validator.addMethod("complexPassword", function(value, element) {
        return this.optional(element) || value.length >= 8 && /[a-z]/g.test(value) && /[A-Z]/g.test(value) && /[0-9]/g.test(value);
    }, msg['MSG_PASSWORD_NOT_COMPLEX']);
    
    // password recovery form
    $('#password-new-form-email').validate({
        rules : {
            recoveremail : 'email',
        },
        submitHandler: function(form) {
            const $form = $(form);

            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                dataType: 'json',
                beforeSend: function () {
                    $form.find(':input').prop('disabled', true);
                },
                success: function (data) {
                    if (data.success) {
                        const email = $('#recoveremail').val();
                        showMessageBox('success', msg['MSG_RECOVEREMAILSENT']);
                        $('#password-new-form-email')[0].style.removeProperty("display");
                        $('#password-new-form-email').addClass('collapse');
                        $('#password-new-form-token').removeClass('collapse')
                            .find('[name="email"]').val(email);
                    }
                    else {
                        showMessageBox('danger', msg[data.errors.message] || msg['ERR_INVALIDMAIL']);
                    }
                },
                failed: function () {
                    showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
                },
                complete: function () {
                    $form.find(':input').prop('disabled', false);
                }
            });
    
        }
    });

    $('#password-new-form-token').validate({
        rules: {
            token: 'required',
            password: {
                required: true,
                complexPassword: true
            }
        },
        submitHandler: function (form) {
            const $form = $(form);

            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                dataType: 'json',
                beforeSend: function (data) {
                    $form.find(':input').prop('disabled', true);
                },
                success: function (data) {
                    if (data.success) {
                        showMessageBox('success', msg['MSG_PASSWORD_OK']);
                        $('#password-new-form-token')[0].style.removeProperty("display");
                        $('#password-new-form-token').addClass('collapse');
                        $('#login-form')[0].style.removeProperty("display");
                        $('#login-form').removeClass('collapse');
                    }
                    else if (data.errors.message == 'fault') {
                        showMessageBox('danger', msg['ERR_WRONG_TOKEN']);
                    }
                    else {
                        showMessageBox('danger', msg[data.errors.message] || msg['MSG_GENERIC_ERROR']);
                    }
                },
                failed: function (data) {
                    showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
                },
                complete: function (data) {
                    $form.find(':input').prop('disabled', false);
                }
            });

            return false;
        }
    });

    $.validator.messages.required = messages_requiredfield;

    $('#login-form').validate({
        rules: {
            username: 'required',
            password: 'required'
        }
    });

});